// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ZcZA","rightAdornment":"Header_rightAdornment__BdA6E"};